import { ITag } from "../user";

export enum TypeConversation {
  Direct = 0,
  Group = 1
}

export interface IPageConversationRs {
  id?: string;
  title: string;
  avatar: string;
  type: number;
  participantIds: string[];
  participants: ITag[];
  unreadCount: number;
  online?: boolean;
  lastMessageId?: string;
  lastMessageContent?: string;
  lastMessageAt?: Date;
  CreatedDate?: Date;
}

export interface IConversationReq {
  id?: string;
  title: string;
  type: number;
  reciver?: ITag;
  participantIds: string[];
  participants: ITag[];
  text?: string;
  unread?: boolean;
  online?: boolean;
  isOpenMessage?: boolean;
  isHiddenChat?: boolean;
  isCreateGroupChat?: boolean;
  messages?: IMessagesRs[];
  pageSize?: number;
  unreadCount?: number;
  selectedFiles?: File[];
}

export interface IMessagesRs {
  id?: string;
  conversationId: string;
  senderId: string;
  sender: ITag;
  content: string;
  contentJson: string;
  isSystem: boolean;
  seenBy: ITag[];
  createdDate: Date;
  attachments: IMessageAttachmentFileRs[];
}

export interface IMessagesReq {
  conversationId?: string;
  senderId?: string;
  content: string;
  contentJson?: string;
  replyTo?: string;
  attachments: IMessageAttachmentFileRequest[];
  sendFireBaseMessenger: ISendFireBaseMessenger;
}

export interface ICreateConversationReq {
  id?: string;
  title: string;
  messageContent: string;
  type: number;
  participantIds: string[];
  attachments: IMessageAttachmentFileRequest[];
}

export interface IGetPageConversationReq {
  conversationId?: string;
  currentPage: number;
  pageSize: number;
  keySearch?: string;
}

export interface IUpdateGroupTitleReq {
  id: string;
  title: string;
}

export interface IMarkAsReadReq {
  ConversationId: string;
  UserId: string;
  LastMessageId?: string;
}

export interface IMessageAttachmentFileRs {
  id: string;
  messageId: string;
  fileName: string;
  path: string;
  contentType: string;
  extension: string;
}

export interface IMessageAttachmentFileRequest {
  fileName: string;
  path: string;
  contentType: string;
  extension: string;
}

export interface ISendFireBaseMessenger {
  titleGroup?: string;
  mentionedUserIds?: string[];
}
